import React, {FC, useMemo} from 'react';

import {ModalOpenerComponent} from 'components/modal-opener-component';
import {ActionButton} from 'components/table/action/action-button';
import {ITableActionProps} from 'components/table/action/table-action-types';
import {STATUS_CODES} from 'components/table/columns/factor-influence-status-cell/factor-influence-status-cell.consts';
import {TEntity} from 'modules/data';
import {selectTableEntityData} from 'modules/data/data-selectors';
import {useAppSelector} from 'store/config/hooks';

import {useFactorInfluenceInfoServiceModal} from '../hooks';
import {FactorInfluenceInfoServiceModalForm} from './factor-influence-info-service-modal-form';

interface IFactorInfluenceInfoServiceModalOpenerProps extends ITableActionProps {
    serviceName?: string;
}

export const FactorInfluenceInfoServiceModalOpener: FC<IFactorInfluenceInfoServiceModalOpenerProps> = ({
    meta,
    wrapper,
    entityName,
    ...props
}: IFactorInfluenceInfoServiceModalOpenerProps) => {
    const tableData = useAppSelector(selectTableEntityData(entityName || ''));
    const selectedRows = useMemo(() => tableData?.selectedRows || [], [tableData?.selectedRows]);

    const {
        modalRef,
        isOpen,
        form,
        setIsOpen,
        handleCloseModal,
        handleFinish,
    } = useFactorInfluenceInfoServiceModal({selectedRows, entityName: entityName || ''});

    const isButtonDisabled = useMemo(() => {
        if (selectedRows.length !== 1) {
            return true;
        }
        const selectedRow = selectedRows[0] as TEntity;
        return selectedRow?.statusText === STATUS_CODES.SEND_SUCCESS;
    }, [selectedRows]);

    const ActionButtonComponent = wrapper || ActionButton;

    return (
        <ModalOpenerComponent
            ref={modalRef}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            handleSave={() => {
                form.submit();
            }}
            handleCancel={setIsModalOpen => {
                handleCloseModal(setIsModalOpen);
            }}
            hideControls={{all: true}}
            component={(
                <>
                    <ActionButtonComponent
                        {...props}
                        actionIcon={meta.actionIcon}
                        disabled={isButtonDisabled}
                    >
                        {meta.actionTitle}
                    </ActionButtonComponent>
                </>
            )}
            modalProps={{
                title: 'Вызвать сервис',
                forceRender: true,
                centered: true,
                className: 'factor-influence-info-service-modal',
            }}
        >
            <FactorInfluenceInfoServiceModalForm
                form={form}
                handleFinish={handleFinish}
            />
        </ModalOpenerComponent>
    );
};

